import * as React from 'react';
import classNames from 'classnames';
import { CollapsiblePanel, Message, PanelList, RadioGroup, TabsAnchoredContent, Text } from 'ui';
import ContactSupport from './ContactSupport';
import { IObjectTypeWithRadioInterface } from '../StoreFrontSettings.interfaces';
import { IRadioItemPartial } from '../../FormComponents/Primitives/RadioGroupPrimitive/RadioGroup.interfaces';
import SvgProductCard from '../../../common/ProductCardSvg/SvgProductCard';
import { IProductCardILayoutTypes, IProductCardILayoutVersions, IScreenType } from '@thryveai/theme-interfaces';
import { i18n } from 'i18n';

const ObjectTypeComponentWithRadio = (props: IObjectTypeWithRadioInterface) => {
  const {
    valuesObject,
    component,
    handleChange,
    level,
    id,
    Footer,
    showAnchors = false,
    displayInline = false,
  } = props;

  const [value, setValue] = React.useState<any>(valuesObject[id]);

  const hasValue = !!valuesObject[id] && valuesObject[id] !== undefined && valuesObject[id] !== null;
  const devices: IScreenType[] = ['tablet', 'mobile'];
  const productCardLayoutTypes = new Set<IProductCardILayoutTypes>([
    'ContainersGrid',
    'ContainersCarousel',
    'FlyerCard',
  ]);

  const data = Array.isArray(component.options)
    ? component.options.map((option) => ({
        ...option,
        explainerText:
          productCardLayoutTypes.has(id as IProductCardILayoutTypes) && option.value
            ? i18n.t(`modules.siteSettings.productCardLayouts.explainerTexts.${id}.${option.value}`)
            : option.explainerText,
      }))
    : [];

  const handleRadioChange = (_, value: any) => {
    setValue(value);
    handleChange(id, value);
  };

  React.useEffect(() => {
    setValue(valuesObject[id]);
  }, [valuesObject]);

  const children = (itemData: IRadioItemPartial) => (
    <>
      {productCardLayoutTypes.has(id as IProductCardILayoutTypes) && (
        <div className="svg-product-card-container">
          {devices.map((device) => (
            <SvgProductCard
              key={device}
              location={id as IProductCardILayoutTypes}
              layout={itemData.value as IProductCardILayoutVersions}
              screenSize={device}
              title={device === 'tablet' ? 'Desktop & Tablet' : 'Mobile Web'}
            />
          ))}
        </div>
      )}
    </>
  );

  const PanelContent = (
    <CollapsiblePanel
      panelHeader={<Text caption={component.title} tag="h2" />}
      panelId={component.title}
      className="stretchToPanelWidth"
    >
      {component.description && <Message caption={component.description} type="info" showLabel={false} />}
      {!hasValue && <ContactSupport />}
      {component?.options?.length > 0 && (
        <RadioGroup
          onChange={handleRadioChange}
          data={data}
          initValue={value}
          disabled={!hasValue}
          displayInline={displayInline}
        >
          {children}
        </RadioGroup>
      )}
    </CollapsiblePanel>
  );

  const generateAnchors = () => {
    return <TabsAnchoredContent caption={component.title}>{PanelContent}</TabsAnchoredContent>;
  };

  return (
    <PanelList className={classNames(level > 1 && 'remove-border')}>
      {showAnchors ? generateAnchors() : PanelContent}
      {Footer}
    </PanelList>
  );
};
export default ObjectTypeComponentWithRadio;
